import React from 'react';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';
import helpers from '../../resources/helpers';

import FormElementWrapper from '../core/FormElementWrapper';

import './RadioButtonList.scss';

class RadioButtonList extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			hasFocus: false,
			touched: false,
			hasValue: (props.value || '') !== '',
			value: props.value,
		};

		this.inputRef = React.createRef();
		this.handleLabelClick = this.handleLabelClick.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
		this.handleValueChange = this.handleValueChange.bind(this);
		this.renderRadioButton = this.renderRadioButton.bind(this);
	}

	componentWillReceiveProps(props) {
		const value = props.value;
		this.setState({
			hasValue: (value || '') !== '',
			value,
		});
	}

	// Event Handlers
	handleLabelClick() {
		this.inputRef.current.focus();
	}

	handleFocus() {
		if (this.props.onFocus) {
			this.props.onFocus();
		}
		this.setState({
			hasFocus: true,
			touched: true,
		});
	}

	handleBlur() {
		if (this.props.onBlur) {
			this.props.onBlur(this.state.value);
		}
		this.setState({
			hasFocus: false,
		});
	}

	handleValueChange(value) {
		this.props.setValue(value);
		if (this.props.onChange) {
			this.props.onChange(value, this.state.touched);
		}
		this.setState({
			value: value,
			hasValue: value !== '',
		});
	}

	//Sub-Renderer
	renderRadioButton(option, idx) {
		const props = this.props;
		const optValue = typeof option === 'string' ? option : option.value.toString();
		const display = typeof option === 'string' ? option : option.display;
		return (
			<div key={idx} className="radio-button-list__entry" onClick={() => this.handleValueChange(optValue)}>
				<div className="radio-button-list__container">
					<input
						type="radio"
						name={props.name}
						value={optValue}
						checked={optValue === this.state.value}
						onChange={() => this.handleValueChange(optValue)}
						onFocus={this.handleFocus}
						onBlur={this.handleBlur}
						className="radio-button-list__input"
					/>
					<span className="radio-button-list__dot"></span>
				</div>
				<span className="radio-button-list__label">{display}</span>
			</div>
		);
	}

	render() {
		const props = this.props;

		const { showError, errorMessage } = helpers.shouldComponentShowError({
			showError: this.props.showError,
			formHasHadAnInValidSubmit: this.props.formHasHadAnInValidSubmit,
			required: this.props.required,
			getErrorMessage: () => props.errorMessage,
			errorMessage: props.errorMessage,
		});

		return (
			<FormElementWrapper
				label={props.label}
				hideLabel={props.hideLabel}
				tooltip={props.tooltip}
				optionalLabel={props.optionalLabel}
				name={props.name}
				required={props.required}
				hasFocus={this.state.hasFocus}
				hasValue={this.state.hasValue}
				lockLabel={true}
				showError={showError}
				errorMessage={errorMessage}
				onLabelClick={this.handleLabelClick}>
				<React.Fragment>{(props.options || []).map(this.renderRadioButton)}</React.Fragment>
			</FormElementWrapper>
		);
	}
}

RadioButtonList.propTypes = {
	required: PropTypes.bool,
	hidden: PropTypes.bool,
	hideLabel: PropTypes.bool,
	lockLabel: PropTypes.bool,
	label: PropTypes.string,
	tooltip: PropTypes.string,
	optionalLabel: PropTypes.string,
	options: PropTypes.array,
	className: PropTypes.string,
	showError: PropTypes.any,
	errorMessage: PropTypes.string,
	getErrorMessage: PropTypes.func,
	name: PropTypes.string.isRequired,
	value: PropTypes.any,
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
	onBlur: PropTypes.func,
	formHasHadAnInValidSubmit: PropTypes.bool,
};

export default withFormsy(RadioButtonList);
